import Api from './rest/PayoutApi';

export default new Api();
